<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">

            <el-form-item label="用户账号" prop="account" :error="formErrorMsg.account">
                <el-input v-model="formData.account"></el-input>
            </el-form-item>

            <el-form-item label="用户密码" prop="password">
                <el-input v-model="formData.password" show-password></el-input>
            </el-form-item>

            <el-form-item label="用户角色" prop="roleCodes">
                <role-select v-model="formData.roleCodes"></role-select>

            </el-form-item>

            <el-form-item label="用户昵称" prop="nickname">
                <el-input v-model="formData.nickname"></el-input>
            </el-form-item>

            <el-form-item label="用户姓名" prop="realName">
                <el-input v-model="formData.realName"></el-input>
            </el-form-item>

            <el-form-item label="用户邮箱" prop="email">
                <el-input v-model="formData.email"></el-input>
            </el-form-item>

            <el-form-item label="手机号码" prop="mobile">
                <el-input v-model="formData.mobile"></el-input>
            </el-form-item>

            <el-form-item label="出生日期" prop="birthday">
                <el-date-picker
                        v-model="formData.birthday"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="用户状态" prop="status">

                <dict-select v-model="formData.status" type-flag="USER_STATUS"></dict-select>

                <!--                <el-select v-model="formData.status" placeholder="请选择用户状态">-->
                <!--                    <el-option label="正常" value="1"></el-option>-->
                <!--                    <el-option label="禁用" value="0"></el-option>-->
                <!--                </el-select>-->
            </el-form-item>


            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    import RoleSelect from "../../components/RoleSelect";
    import DictSelect from "../../components/DictSelect";

    export default {
        name: "UserAdd",
        components: {DictSelect, RoleSelect},
        data() {
            return {
                api: {
                    add: this.$api.user.add
                },
                formErrorMsg: {account: ''},
                formData: {
                    account: '',
                    nickname: '',
                    roleCodes: [],
                    realName: '',
                    email: '',
                    mobile: '',
                    birthday: '',
                    status: '1',
                },
                rules: {
                    account: [
                        {required: true, message: '请输入用户账号', trigger: 'blur'},
                        {min: 5, max: 20, message: '5-20位英文字母或数字', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入用户密码', trigger: 'blur'},
                        {min: 6, max: 20, message: '6-20位英文或数字', trigger: 'blur'}
                    ],
                    nickname: [
                        {required: true, message: '请输入用户昵称', trigger: 'blur'}
                    ],
                    roleCodes: [
                        {required: true, message: '请选择用户角色', trigger: 'blur'}
                    ],
                    mobile: {
                        validator: (rule, value, callback) => {


                            if (!value) {
                                callback();
                                return;
                            }

                            let reg = /^[1][3,4,5,7,8][0-9]{9}$/;
                            if (!reg.test(value)) {
                                callback("手机号码格式不正确")
                            } else {
                                callback()
                            }

                        }, trigger: 'blur'
                    },
                    email: {
                        validator: (rule, value, callback) => {


                            if (!value) {
                                callback();
                                return;
                            }

                            let reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
                            if (!reg.test(value)) {
                                callback("邮箱格式不正确")
                            } else {
                                callback()
                            }


                        }, trigger: 'blur'
                    }




            },
        }

    }
    ,
    methods: {
        handleSubmit(form)
        {

            let vm = this;
            vm.$refs[form].validate((valid) => {
                if (valid) {
                    vm.$http.post(vm.api.add, this.formData).then((resp) => {

                        if (resp.data.status === 200) {
                            vm.$message({
                                type: 'success',
                                message: resp.data.desc
                            });
                            vm.$router.cgBack();
                        } else if (resp.data.status === 400) {

                            console.log(vm.$refs[form]);


                            resp.data.data.errorFields.forEach(function (a) {

                                vm.formErrorMsg[a.name] = '';
                                vm.$nextTick(() => {
                                    vm.formErrorMsg[a.name] = a.message;
                                });


                            });

                            if (resp.data.desc) {
                                vm.$message({
                                    type: "error",
                                    message: resp.data.desc
                                });
                            }


                        } else {
                            vm.$message({
                                type: "error",
                                message: resp.data.desc
                            })
                        }

                    });
                    return true;
                } else {
                    return false;
                }
            });

        }
    ,
        handleReset(form)
        {
            this.$refs[form].resetFields();
        }
    }
    ,
    created()
    {
        // let vm = this;

    }
    }
</script>

<style lang="scss" scoped>

    .fb-form {
        max-width: 500px;
    }

</style>